import React from 'react';
import { Link } from 'react-router-dom';
import { calculaPrevision, formatMs, calculateDiferencia } from '../utils/time';
import '../scss/ResultadoList.css';


class ResultadoList extends React.Component {
  // ...
  constructor(props) {
    super(props)
    this.state = {
      time: 0
    }
  }

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 10000)
  }

  UNSAFE_componentWillUpdate() { // eslint-disable-line
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  render() {
    const { resultados, sectores, controles, competicion, controlId, mostrarNeto } = this.props
    //console.log(resultados)
    return <div>
      <ul className='resultado-list'>
        {resultados.map((resultado) => {
          // tiempo de paso en este control
          
          const tiempo = resultado['control_' + controlId + '_tiempo']          
          const prevision = calculaPrevision(competicion, controles, sectores, resultado)
         

          return (
            <li key={resultado.dorsal} className='resultado-list__row'>
              <Link to={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}>
                <div className='resultado-item'>
                  {resultado.descalificado ? (
                    <div className='resultado-item__puesto'>!</div>
                  ) : (
                    <div className='resultado-item__puesto'>
                      {resultado['control_' + controlId + '_puesto'] || '?'}
                    </div>
                  )}
                  {resultado.preload ? (
                    <div className='resultado-item__nombre--preload' />
                  ) : (
                    <div className='resultado-item__nombre'>
                      {resultado.nombre} {resultado.apellidos}
                    </div>
                  )}
                  {resultado.preload ? (
                    <div className='resultado-item__info--preload' />
                  ) : (
                    <div className='resultado-item__info'>
                      Dorsal <strong>{resultado.dorsal}</strong>&nbsp;
                      {/* inscrito.localidad ? ', ' + inscrito.localidad : '' */}
                      {resultado.categoriaNombre ? ', ' + resultado.categoriaNombre : ''}
                      {resultado.clubNombre ? ', ' + resultado.clubNombre : ''}

                      {(prevision.tiempoTotal !== null && prevision.porcentaje < 100) && (
                        <span>
                          | Prev. {prevision.control ? prevision.control.nombre : 'Meta'}:
                          <strong>{formatMs(prevision.tiempoTotal)}</strong>
                        </span>
                      )}
                    </div>
                  )}
                  {resultado.descalificado ? (
                    <div className='resultado-item__tiempo'>DESCAL.</div>
                  ) : (
                    <div className='resultado-item__tiempo'>
                      {formatMs(tiempo)}                      
                      <div className='resultado-item__tiempo--diferencia' >{calculateDiferencia(resultados, resultado.dorsal, controlId)}</div>
                    </div>
                  )}
                  {mostrarNeto &&
                    <div className='resultado-item__neto'>Neto: {{ mostrarNeto }}</div>
                  }
                  {prevision.porcentaje !== null &&
                    <div className={'resultado-item__progreso'}>
                      <div
                        className={'resultado-item__progreso--completado'}
                        style={{ width: prevision.porcentaje + '%' }}
                      />
                    </div>
                  }
                </div>
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  }
}

export default ResultadoList



// WEBPACK FOOTER //
// ./src/components/ResultadoList.js